module.exports = __webpack_public_path__ + "img/icon_map_5_off_100.3b9cc515.png";